import type { IconSvgObject } from './types';

const PackageReceiveIcon: IconSvgObject = [
  ["path", { d: "M7.49805 5L2.99805 7L11.998 11L20.998 7L16.498 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.99805 5.5L11.998 7.5L13.998 5.5M11.998 2V6.89122", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5.99805 12L7.99805 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3.00195 7L3.00195 18L11.998 22M11.998 22L21.002 18V7.01357M11.998 22V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default PackageReceiveIcon;
